import {useMemo, Navigate, useEffect} from 'external/react'
import {styled, Box} from 'external/material'
import useMenu from 'hooks/menu'
import useTranslations from 'hooks/translations'

import DashboardContentTabs from './DashboardContentTabs'
import DashboardActivity from './DashboardActivity'
import DashboardMessages from './DashboardMessages'

const StyledDashBoardContent = styled(Box)(dashboardContentMobileStyles)

export default function DashboardContentMobile() {
  const {dashboardTab, changeDashboardTab} = useMenu()
  const {language} = useTranslations()
  
  const ContentComponent = useMemo(() => {
    switch(dashboardTab) {
      case 'messages':
        return DashboardMessages
      case 'recent-activities':
        return DashboardActivity
      case 'videos':
        return () => {
          useEffect(()=> { changeDashboardTab('messages')}, [])
          return <Navigate to={`/${language || 'es'}/videos`} />
      }
      default:
        return DashboardMessages
    }
    
  }, [dashboardTab, language])
  return (
    <StyledDashBoardContent className="dashboardContentWrapper">
      <DashboardContentTabs className="dashboardContentTabs" />
      <ContentComponent className="dashboardContent" />
    </StyledDashBoardContent>
  )
}

function dashboardContentMobileStyles() {
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 0px 0px 20px',
    flexGrow: 1,
    overflowY: 'hidden',
    "& .dashboardContentTabs": {
      flexShrink: 0,
      marginTop: 20,
    }, 
    "& .dashboardContent": {
      display: 'flex',
      paddingRight: 5,
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'hidden'
    }
  }
}
